import { alpha } from '@mui/material/styles';

export const SIDE_NAV_WIDTH = 270;

const evidentNavVars = (theme) => {
  const primary = theme.palette.primary.main;

  return {
    '--nav-bg': theme.palette.neutral[800],
    '--nav-border-color': 'transparent',
    '--nav-color': theme.palette.common.white,
    '--nav-footer-bg': 'rgba(255, 255, 255, 0.04)',
    '--nav-footer-border': theme.palette.neutral[700],
    '--nav-item-active-bg': 'rgba(255, 255, 255, 0.04)',
    '--nav-item-active-color': theme.palette.common.white,
    '--nav-item-chevron-color': theme.palette.neutral[600],
    '--nav-item-color': theme.palette.neutral[400],
    '--nav-item-disabled-color': theme.palette.neutral[500],
    '--nav-item-hover-bg': 'rgba(255, 255, 255, 0.04)',
    '--nav-item-icon-active-bg': alpha(primary, 0.22),
    '--nav-item-icon-active-color': primary,
    '--nav-item-icon-color': theme.palette.neutral[400],
    '--nav-item-icon-disabled-color': theme.palette.neutral[500],
    '--nav-logo-border': theme.palette.neutral[700],
    '--nav-scrollbar-color': theme.palette.neutral[400],
    '--nav-section-title-color': theme.palette.neutral[400]
  };
};

export const getNavCssVars = (theme, color = 'evident') => {
  if (color === 'evident') {
    return evidentNavVars(theme);
  }

  const isDark = theme.palette.mode === 'dark';
  const primary = theme.palette.primary.main;

  const shared = {
    '--nav-footer-bg': isDark ? alpha('#ffffff', 0.04) : alpha(primary, 0.05),
    '--nav-footer-border': isDark ? theme.palette.neutral[800] : theme.palette.divider,
    '--nav-item-active-bg': alpha(primary, isDark ? 0.16 : 0.1),
    '--nav-item-active-color': isDark ? theme.palette.common.white : theme.palette.text.primary,
    '--nav-item-chevron-color': isDark ? theme.palette.neutral[600] : theme.palette.neutral[400],
    '--nav-item-color': isDark ? theme.palette.neutral[400] : theme.palette.text.secondary,
    '--nav-item-disabled-color': theme.palette.neutral[500],
    '--nav-item-hover-bg': isDark ? alpha('#ffffff', 0.06) : alpha(primary, 0.06),
    '--nav-item-icon-active-bg': alpha(primary, isDark ? 0.22 : 0.12),
    '--nav-item-icon-active-color': primary,
    '--nav-item-icon-color': isDark ? theme.palette.neutral[500] : theme.palette.neutral[500],
    '--nav-item-icon-disabled-color': theme.palette.neutral[600],
    '--nav-logo-border': 'transparent',
    '--nav-scrollbar-color': isDark ? theme.palette.neutral[600] : theme.palette.neutral[400],
    '--nav-section-title-color': theme.palette.neutral[500]
  };

  if (color === 'discreet') {
    return {
      ...shared,
      '--nav-bg': isDark ? theme.palette.neutral[900] : theme.palette.neutral[50],
      '--nav-border-color': isDark ? theme.palette.neutral[800] : theme.palette.divider,
      '--nav-color': isDark ? theme.palette.neutral[100] : theme.palette.text.primary
    };
  }

  return {
    ...shared,
    '--nav-bg': theme.palette.background.default,
    '--nav-border-color': isDark ? theme.palette.neutral[800] : theme.palette.divider,
    '--nav-color': isDark ? theme.palette.neutral[100] : theme.palette.text.primary
  };
};
